import { useEffect, useState } from "react";

const TARGET = new Date("2026-08-01T00:00:00").getTime();

const pad = (n) => String(n).padStart(2, "0");

export const CountdownTimer = () => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  const Box = ({ value, label, testid }) => (
    <div
      className="flex flex-col items-center justify-center px-3 py-3 sm:px-7 sm:py-5 glass-card rounded-2xl min-w-[60px] sm:min-w-[96px]"
      data-testid={`countdown-${testid}`}
    >
      <div className="font-serif text-2xl sm:text-5xl font-medium leading-none text-[#0B0A4A] tabular-nums">
        {pad(value)}
      </div>
      <div className="mt-1.5 sm:mt-2 text-[9px] sm:text-xs uppercase tracking-[0.22em] sm:tracking-[0.25em] text-[#3E1A7A] font-medium">
        {label}
      </div>
    </div>
  );

  return (
    <div className="flex items-center justify-center gap-1.5 sm:gap-3" data-testid="countdown-timer">
      <Box value={days} label="Days" testid="days" />
      <span className="text-xl sm:text-3xl text-[#E0D0F5] font-light">·</span>
      <Box value={hours} label="Hours" testid="hours" />
      <span className="text-xl sm:text-3xl text-[#E0D0F5] font-light">·</span>
      <Box value={minutes} label="Min" testid="minutes" />
      <span className="text-xl sm:text-3xl text-[#E0D0F5] font-light">·</span>
      <Box value={seconds} label="Sec" testid="seconds" />
    </div>
  );
};

export default CountdownTimer;
